export default __webpack_public_path__ + "static/media/icon-nintendo.f744ac3a.svg";